<mat-card appearance="outlined">
  <mat-card-header>
    <div mat-card-avatar>
      <mat-icon>warning</mat-icon>
    </div>
    <mat-card-title>{{ title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div>
      <div [innerHTML]="text"></div>
      <div>
        <mat-label> Set Inspection Result: </mat-label>
        <mat-select
          class="select-class"
          id="inspectionResultMultiDropdown"
          [(value)]="inspectionResult"
          (selectionChange)="updateInspectionResult($event.value)"
          >
          @for (option of options; track option) {
            <mat-option [value]="option">
              {{ option }}
            </mat-option>
          }
        </mat-select>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button id="cancel-finish-inspection" (click)="cancel()" mat-button>
      CANCEL
    </button>
    <button
      id="finish-inspection"
      [disabled]="!inspectionResultSelected"
      (click)="finish()"
      mat-button
      color="primary"
      >
      ACCEPT
    </button>
  </mat-card-actions>
</mat-card>
